var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer-popup-container gachi-loading-layer",attrs:{"id":"popup-load"}},[_c('span',{staticClass:"gachi-modal-loader"})])
}]

export { render, staticRenderFns }